<div class="gsm-confirmation-dialog_wrapper">
  <div class="gsm-confirmation-dialog_header">
    <h1 *ngIf="data?.heading" mat-dialog-title>
      <mat-icon *ngIf="data?.icon" class="gsm-confirmation-dialog_icon" inline>{{ data.icon }}</mat-icon>
      {{ data.heading }}
    </h1>
  </div>

  <mat-dialog-content>
    <p *ngIf="data?.content" [innerHTML]="data.content"></p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="false">{{ data?.cancelButtonLabel || 'Abbrechen' }}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ data?.confirmButtonLabel || 'OK' }}</button>
  </mat-dialog-actions>
</div>
